export default "__VITE_ASSET__BkOK313c__"